import { BODY } from './_global-variables.js';

function scrollPositionHeaderClass() {
    if (window.scrollY > 200) {
        BODY.classList.add('state--has-scrolled');
    } else {
        BODY.classList.remove('state--has-scrolled');
    }
}

export { scrollPositionHeaderClass };